import React, { useEffect, useState } from "react";
import axios from "../../axios-instance";
import swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import './BuyerPage.sass';
import styles from './BuyerPage.module.sass';
import { getCustomURLs } from "../../helpers/getCustomURLs";
import PhoneInput from "react-phone-input-2";
import { getCurrentLanguageTexts, setLangCode } from "../../constants/seasonPassPersonalInfoLangs";
import { toast } from "react-toastify";
import NewLoader from "../../components/NewLoader/NewLoader";
import Page404 from "../../components/Page404/Page404"
import CheckBox from "../../components/UI/Checkbox/CheckBox";
import TermsAndConditionsModal from "../SeasonPass/TermsAndConditionsModal/TermsAndConditionsModal";
import { SeasonPassFieldLabel } from "../SeasonPass/SeasonPassFieldLabel";

const MySwal = withReactContent(swal);

function BuyerPage() {
    const [state, setReactState] = useState({
        firstName: '',
        lastName: '',
        physicalAddress: '',
        phoneNumber: '',
        shareTicket: null,
        isLoading: true,
    });
    const [isTermsChecked, setIsTermsChecked] = useState(false);

    const setState = (obj) => { setReactState(v => { return { ...v, ...obj } }) }

    setLangCode('rs');

    const txt = getCurrentLanguageTexts('rs');

    const token = window.location.pathname.split('/')[3];

    const showTermsAndConditionsModal = (ev) => {
      ev.preventDefault();
      MySwal.fire({
        html: <TermsAndConditionsModal />,
        showConfirmButton: true,
        showCloseButton: true,
        customClass: "partizan-modal member-page-modal",
      });
    };

    useEffect(() => {
        axios.get(getCustomURLs().API_URL + `/ShareTicket/${token}`)
            .then(r => {
                setState({
                    shareTicket: r.data,
                    isLoading: false
                });
            })
            .catch(r => {
                setState({
                    shareTicket: null,
                    isLoading: false
                });
            });
    }, []);

    const acceptTakeTicket = async () => {
        if (!state.shareTicket || state.shareTicket.status !== 1) {
            return;
        }

        if (state.physicalAddress.length < 4) {
          toast.error(txt.BuyerPageTxt['Short address error'])
          return;
        }

        const { data } = await axios.put(getCustomURLs().API_URL + `/ShareTicket/TakeTicket/${token}`, {
            fullName: `${state.firstName} ${state.lastName}`,
            physicalAddress: state.physicalAddress,
            phoneNumber: state.phoneNumber,
        });

        setState({ shareTicket: data });
        toast.success(txt.PersonalInfoUpdating.success);
    }

    const isValid = state.firstName && state.lastName && state.physicalAddress && state.physicalAddress && state.phoneNumber.length >=6;

    const handleLoader = () => {
        return <>
            {state.isLoading
                && <NewLoader />}
        </>
    }

    const handleStates = () => {

        if (state.isLoading) {
            return <NewLoader />;
        }

        if (!state.shareTicket || state.shareTicket.status === 0) {
            return <Page404 isBackBtn={false} />;
        }

        if (state.shareTicket.status === 2) {
            return <div className={styles['ticket-taken-container']}>
                <h2>{txt.BuyerPageTxt['This ticket is already taken']}</h2></div>;
        }

        return null;
    }

    return <>
        <section className="buyer-page">

            {handleLoader()}

            <div className="admin-container">
              <div className="seasonpass-pers-info__logo seasonpass-pers-info__header-logo-wrapper buyer-page__logo"></div>
                {
                    handleStates()
                    || <>
                        <h2>{txt.BuyerPageTxt['Share ticket']}</h2>

                        <div className="admin-container__row">

                            <div className="admin-container__block">
                                <SeasonPassFieldLabel
                                  label={txt.dataFormTxt.firstName}
                                  isRequired={!state.firstName}
                                  className="buyer-page__fields-label"
                                  shouldWrapInLabel={false}
                                >
                                  <input
                                    type="text"
                                    name="firstname"
                                    placeholder={txt.dataFormTxt.firstName}
                                    value={state.firstName}
                                    onChange={e => setState({ firstName: e.target.value })}
                                  />
                                </SeasonPassFieldLabel>
                            </div>

                            <div className="admin-container__block">
                                <SeasonPassFieldLabel
                                  label={txt.dataFormTxt.lastName}
                                  isRequired={!state.lastName}
                                  className="buyer-page__fields-label"
                                  shouldWrapInLabel={false}
                                >
                                  <input
                                    type="text"
                                    name="lastname"
                                    placeholder={txt.dataFormTxt.lastName}
                                    value={state.lastName}
                                    onChange={e => setState({ lastName: e.target.value })}
                                  />
                                </SeasonPassFieldLabel>
                            </div>

                        </div>

                        <div className="admin-container__row">

                            <div className="admin-container__block">
                                <SeasonPassFieldLabel
                                  label={txt.dataFormTxt.phone}
                                  isRequired={state.phoneNumber.length < 6}
                                  className="buyer-page__fields-label"
                                  shouldWrapInLabel={false}
                                >
                                  <PhoneInput
                                    inputClass="custom-phone-number-input"
                                    buttonClass="custom-phone-number-button"
                                    dropdownClass="custom-phone-number-dropdown"
                                    searchClass="custom-phone-number-search"
                                    dropdownStyle={{ width: 304 }}
                                    searchPlaceholder={txt.dataFormTxt.countrySearchPlaceholder}
                                    searchNotFound={txt.dataFormTxt.countryNotFound}
                                    country={!state.phoneNumber ? 'rs' : ''}
                                    enableSearch={true}
                                    disableSearchIcon={true}
                                    value={state.phoneNumber}
                                    onChange={e => setState({ phoneNumber: e })}
                                  />
                                </SeasonPassFieldLabel>
                            </div>

                            <div className="admin-container__block">
                                <SeasonPassFieldLabel
                                  label={`${txt.dataFormTxt.city}, ${txt.dataFormTxt.streetAndHouse}`}
                                  isRequired={!state.physicalAddress}
                                  className="buyer-page__fields-label"
                                  shouldWrapInLabel={false}
                                >
                                  <input
                                    type="text"
                                    name="physicalAddress"
                                    placeholder={`${txt.dataFormTxt.city}, ${txt.dataFormTxt.streetAndHouse}`}
                                    value={state.physicalAddress}
                                    onChange={e => setState({ physicalAddress: e.target.value })}
                                  />
                                </SeasonPassFieldLabel>
                            </div>

                        </div>

                        <div className="admin-container__row">
                          <div className="admin-container__block">
                            <CheckBox
                              checked={isTermsChecked}
                              id="terms-and-conditions-checkbox"
                              name="terms-and-conditions-checkbox"
                              onChange={() => setIsTermsChecked(!isTermsChecked)}
                            >
                              <span className="partizan-open-selling__text-medium-small">
                                {txt.buyMembershipTxt.iAgreeWith}
                                <span
                                  className="partizan-open-selling__terms-of-service-text" style={{ color: '#d7b36c' }}
                                  onClick={showTermsAndConditionsModal}
                                >
                                  {txt.buyMembershipTxt.termsOfService}
                                </span>
                              </span>
                            </CheckBox>
                          </div>

                          <div className="admin-container__block"></div>
                        </div>

                        <button className="btn-primary buyer-page__submit" disabled={!isValid || !isTermsChecked} onClick={acceptTakeTicket}>{txt.dataFormTxt.saveChanges}</button>
                    </>
                }

            </div>


        </section>
    </>
}

export default BuyerPage;